var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRabbitLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 266 276.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h266v273.1H0z",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.2 158.2c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5m63.2-118.7c0 2-1.6 3.5-3.5 3.5-2 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5m82.2 114.4c-.3 1.5-1.7 2.4-3.2 2.1s-2.4-1.7-2.1-3.2 1.7-2.4 3.2-2.1a2.74 2.74 0 0 1 2.1 3.2m4-44.1c-.3 1.5-1.7 2.4-3.2 2.1s-2.4-1.7-2.1-3.2 1.7-2.4 3.2-2.1c1.4.3 2.3 1.8 2.1 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2 115.8c0 2-1.5 3.6-3.5 3.6-1.9 0-3.6-1.5-3.6-3.5s1.5-3.6 3.5-3.6 3.6 1.6 3.6 3.5m-82.6-73.7c0 1.7-1.4 3.2-3.2 3.2-1.7 0-3.2-1.4-3.2-3.2 0-1.7 1.4-3.2 3.2-3.2s3.2 1.5 3.2 3.2M112.2 160c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5c1.3 0 2.5 1.1 2.5 2.5m12.4-4.3c-.1 9.4 0 25.6 6.3 40.3 0 0 15.7 39.8 35 35.4 0 0 1.6-3.5-5.9-6.7-7.1-3-28.2-12.7-26.5-57.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 182.1c.5-.8 30.6-67.2 46.3-7.6l-9.6.9c-1.7-5.7-3.1-7.6-3.7-7.8-1.7-.5-9.7 13.5-9.7 13.5l-23.3 1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.2 158.2c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    x: 19.1,
    y: -36.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z",
    x: -32.2,
    y: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1 177.4c-.2 1.2-1.4 1.9-2.5 1.7-1.2-.2-1.9-1.4-1.7-2.5.2-1.2 1.4-1.9 2.5-1.7 1.2.3 1.9 1.4 1.7 2.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z",
    x: -1.6,
    y: 33.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    x: -3.6,
    y: 25.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 26c0-1.6 1.3-2.8 2.8-2.8 1.6 0 2.8 1.3 2.8 2.8 0 1.6-1.3 2.8-2.8 2.8S248 27.6 248 26m11.1 208c.2-1 1.2-1.7 2.2-1.5s1.7 1.2 1.5 2.2-1.2 1.7-2.2 1.5-1.7-1.2-1.5-2.2m-75.9-118.2c0 2-1.5 3.6-3.5 3.6-1.9 0-3.6-1.5-3.6-3.5s1.5-3.6 3.5-3.6 3.6 1.6 3.6 3.5m77 87.9a1.785 1.785 0 0 1-3.5-.7 1.74 1.74 0 0 1 2.1-1.4c.9.1 1.6 1.1 1.4 2.1m-148-43.7c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5c1.3 0 2.5 1.1 2.5 2.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.6 150.1c-1.4 52-44.6 93.1-96.7 91.8-52-1.4-93.1-44.7-91.7-96.7s44.6-93.1 96.7-91.7c52 1.3 93 44.6 91.7 96.6",
    fill: "#c1b697"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.2 167.8c-10-7.2-54.3-36.9-54.3-36.9l-21.1-15.2-1.1.7 20.2 15.3c-2.7-.3-8.3 2.6-17.1 5.1-8.8 2.4-12.5-2.1-18.3-11.7-5.7-9.6 2-9.9 2-9.9 10.9 4.4 13.6-.4 13.6-.4-14.9-28.2-24.6-25-24.6-25-4.6 1.2-7.4-1-7.4-1s-4.2-5.1-4-11.7c.1-6.6-18.2-38.5-26-47.5 0 0-12.7-17-14.5-16.3s-2.7.2.8 9c3.6 8.8 9.2 21 15.8 29.7 6.6 8.8 21.6 28.1 23.2 32.5 1.6 4.5 2.2 6.1-1.8 3.5-4.1-2.6-10.2-22.9-31.2-41.9S6.8 28.2 6.7 29.1c-.1 1-2.3 14.4 19 32.4 0 0 32.8 20 36.3 30.3 0 0 5.2 3.7-5.8 12.6-11.1 8.9-28.3 53.2-12.2 87.2s36.3 40.7 40.5 47.6c1.9 3.2 6.6 17.4-1.3 21 0 0-1 6.2 5.6 4s17.9-16.8-3.4-28.5c0 0-7.4-6.1 3.2.3 10.5 6.4 37.1-3.4 40.3-43.6 0 0 .5-4.4 1.9-3.3s-5.1 25.8 2.2 48.5c0 0 12 41 31.6 38.4 0 0 1.9-3.3-5.2-7.2-7.2-3.9-29-16.4-20-66.7 9.1-50.7-28.3-30-29-29.5l-.2.1s-11.2 10.6-25.1 7.6c-14.6-3.1-9.3-29.3 4.6-25.9 0 0 15 .2 24-12.7 0 0 4.5-6.7 13.5-4.6 0 0 29.9 18 47 30.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.4 155.6c-.3 9.4-.4 25.6 5.6 40.4 0 0 15 40.1 34.4 36 0 0 1.7-3.5-5.8-6.8-7.1-3.2-27.9-13.2-25.5-57.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2 181.4c.5-.8 31.8-66.7 46.4-6.8l-9.6.8c-1.6-5.8-2.9-7.6-3.6-7.8-1.7-.5-10 13.3-10 13.3l-23.2.5z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M201.1 176.9c.1 5.6-4.4 10.2-9.9 10.3-5.6.1-10.2-4.3-10.3-9.9s4.3-10.2 9.9-10.3 10.2 4.3 10.3 9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M194.8 161.8c0 .5-.3 1-.7 1.3-.2.2-.5.2-.8.2a1.54 1.54 0 0 1-1.5-1.5 1.47 1.47 0 0 1 1.5-1.5 1.54 1.54 0 0 1 1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M198.8 163c-.1.5-.5.9-.9 1.1-.3.1-.5.1-.8.1-.8-.2-1.3-1-1.2-1.8.2-.8 1-1.3 1.8-1.2.8.2 1.3 1 1.1 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M202.5 165.9c-.3.5-.7.7-1.2.8-.3 0-.6-.1-.8-.2-.7-.4-1-1.3-.6-2.1.4-.7 1.3-1 2.1-.6.6.5.9 1.4.5 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M205.1 169.8c-.4.3-.9.4-1.4.3-.3-.1-.5-.2-.7-.5-.5-.6-.5-1.6.2-2.1.6-.5 1.6-.5 2.1.2a1.46 1.46 0 0 1-.2 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "M206 175.2c-.5.2-1 .1-1.4-.1-.2-.2-.4-.4-.5-.6-.3-.8 0-1.6.8-2 .8-.3 1.6 0 2 .8.2.7-.2 1.6-.9 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M206.3 179.9c-.5.1-1-.1-1.4-.5-.2-.2-.3-.5-.3-.8-.1-.8.4-1.6 1.3-1.7.8-.1 1.6.4 1.7 1.3.1.8-.4 1.6-1.3 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "M205.2 183.1c-.5 0-1-.3-1.3-.7-.1-.2-.2-.5-.2-.8a1.54 1.54 0 0 1 1.5-1.5 1.54 1.54 0 0 1 1.5 1.5 1.47 1.47 0 0 1-1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M203.9 187.1c-.5-.1-.9-.5-1.1-1-.1-.3-.1-.6-.1-.8.2-.8 1-1.3 1.8-1.1s1.3 1 1.1 1.8c-.1.8-.9 1.3-1.7 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M201.8 189.6c-.5-.3-.7-.7-.8-1.2 0-.3.1-.6.2-.8.4-.7 1.3-1 2-.6s1 1.3.6 2c-.3.7-1.2 1-2 .6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "M198 192.2a1.82 1.82 0 0 1-.3-1.4c.1-.3.2-.5.5-.7.6-.5 1.6-.5 2.1.2.5.6.5 1.6-.2 2.1-.6.5-1.6.4-2.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M193.8 193.7c-.2-.5-.1-1 .1-1.5.2-.2.4-.4.6-.5.8-.3 1.6 0 2 .8.3.8 0 1.6-.8 2-.7.3-1.5-.1-1.9-.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M189.1 194.1c-.1-.5.1-1 .5-1.4.2-.2.5-.3.8-.4.8-.1 1.6.4 1.7 1.2s-.4 1.6-1.2 1.7c-.9.3-1.6-.3-1.8-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M184.2 192.2c.1-.5.4-1 .8-1.2.2-.1.5-.2.8-.1.8.1 1.4.8 1.3 1.6s-.8 1.4-1.7 1.3a1.46 1.46 0 0 1-1.2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M180.4 190.5c.2-.5.6-.9 1.1-1 .3-.1.6-.1.8 0 .8.3 1.2 1.1.9 1.9s-1.1 1.2-1.9.9c-.8-.2-1.2-1-.9-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M177.1 187.1c.3-.4.8-.6 1.3-.6.3 0 .5.1.8.3.7.5.8 1.4.3 2.1s-1.4.8-2.1.3-.8-1.4-.3-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "M174.9 183c.5-.3 1-.3 1.5-.1.2.1.5.3.6.5.4.7.2 1.6-.4 2.1-.7.5-1.6.3-2.1-.4-.4-.7-.3-1.7.4-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M174 178.6c.5-.1 1 0 1.4.3.2.2.4.4.4.7.2.8-.2 1.6-1 1.9-.8.2-1.6-.2-1.9-1-.2-.8.3-1.6 1.1-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M174.1 173.9c.5 0 1 .2 1.3.7.2.2.3.5.3.8 0 .8-.6 1.5-1.4 1.6-.8 0-1.5-.6-1.6-1.4-.1-.9.6-1.6 1.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M176.2 169.2c.5.1.9.5 1 1a1.1 1.1 0 0 1 0 .8c-.2.8-1 1.3-1.8 1.1s-1.3-1-1.1-1.8c.3-.8 1.2-1.3 1.9-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M182.3 162.9c.4.4.5.9.4 1.4-.1.3-.2.5-.4.7-.6.6-1.5.6-2.1 0s-.6-1.5 0-2.1 1.5-.6 2.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    d: "M186.7 161.5c.2.5.2 1-.1 1.4-.1.2-.4.4-.6.5-.8.4-1.6 0-2-.7a1.59 1.59 0 0 1 .7-2c.8-.3 1.7 0 2 .8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M191.2 161.1c.1.5-.1 1-.5 1.4-.2.2-.5.3-.8.3-.8.1-1.6-.4-1.7-1.3-.1-.8.5-1.6 1.3-1.7.8 0 1.6.5 1.7 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    d: "M195.8 162c-.1.5-.4 1-.8 1.2-.3.1-.5.2-.8.1-.8-.1-1.4-.8-1.3-1.7.1-.8.8-1.4 1.7-1.3.7.1 1.3.9 1.2 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "M242.5 180.1c-.2 1.1-1.3 1.8-2.4 1.6s-1.8-1.3-1.6-2.4 1.3-1.8 2.4-1.6 1.8 1.3 1.6 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    d: "M256.9 185.3c-.2 1.1-1.3 1.8-2.4 1.6s-1.8-1.3-1.6-2.4 1.3-1.8 2.4-1.6c1.1.3 1.8 1.3 1.6 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M178.5 165.7c.5.3.8.7.8 1.2 0 .3 0 .6-.2.8-.4.7-1.3 1-2 .6s-1-1.3-.6-2 1.3-1 2-.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbitLeft);
export default __webpack_public_path__ + "static/media/Rabbit-left.e2b8c7762f6ddd3f13145115d71cb830.svg";
export { ForwardRef as ReactComponent };